import Cookies from 'js-cookie';
export function setToken(token) {
  window.sessionStorage.clear(); // 设置Token时清除所有sessionStorage
  if (token && location.href.indexOf('localhost') > -1) {
    Cookies.set('yjticket', token, { domain: 'localhost' });
  }
  if (token && location.href.indexOf('stg1') > -1) {
    // Cookies.remove('yjticket', { domain: '.septnet.cn' });
    Cookies.set('yjticket', token, { domain: 'septnet.cn' });
  } else if (token && location.href.indexOf('ac.septnet') > -1) {
    //Cookies.remove('yjticket', { domain: '.stg1.septnet.cn' });
    Cookies.set('yjticket', token, { domain: 'septnet.cn' });
  } else if (token && location.href.indexOf('7net.cc') > -1) {
    Cookies.set('7netticket', token, { domain: '7net.cc' });
  }
  return token;
}

export function removeToken() {
  return window.localStorage.removeItem(TokenKey);
}
